var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _ellipse2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 21 1-.8v-11.2c0-1.298.421-2.561 1.2-3.6 1.133-1.511 2.911-2.4 4.8-2.4h-2-2c-1.889 0-3.667.889-4.8 2.4-.779 1.039-1.2 2.302-1.2 3.6v13h1 2z",
    fill: "#66351e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19 17h1v-3c0-3.866 3.134-7 7-7h4 5c0-2.209-2.582-4-7-4h-8c-1.889 0-3.667.889-4.8 2.4-.779 1.039-1.2 2.302-1.2 3.6v11.2z",
    fill: "#4d2817"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29 2h-12c-2.192 0-4.285 1.047-5.6 2.8-.903 1.203-1.4 2.695-1.4 4.2v16h2v-16c0-1.075.355-2.141 1-3 .939-1.252 2.434-2 4-2h12c3.939 0 6 1.509 6 3h2c0-2.489-2.474-5-8-5z",
    fill: "#606060"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41 43.354c2.783 1.127 5 2.412 5 3.646v15h-42v-15c0-3.314 16-7 16-7h10z",
    fill: "#d0382a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m41 46.354-11-3.354h-10s-14.12 3.254-15.829 6.395l-.171-2.395c0-3.314 16-7 16-7h10l11 3.354c2.783 1.127 5 2.412 5 3.646l-.173 2.419c-.55-1.05-2.478-2.114-4.827-3.065z",
    fill: "#b33024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m10 30h2v32h-2z",
    fill: "#878787"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m41 28v-4c0-2.209-1.791-4-4-4h-1v8z",
    fill: "#606060"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#66351e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31 10v-3h-4c-3.866 0-7 3.134-7 7v3h4c3.866 0 7-3.134 7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 10c0 3.866-3.134 7-7 7h6c3.866 0 7-3.134 7-7v-3h-1-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 17h6c1.075 0 2.09-.25 3-.683v-.011.011c2.363-1.124 4-3.527 4-6.317v-3h-6v3c0 3.866-3.134 7-7 7z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m37 20h-1v2c2.209 0 4 1.791 4 4v2h1v-4c0-2.209-1.791-4-4-4z",
    fill: "#878787"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20.862 36.376c.747.41 1.584.624 2.436.624h3.405c.851 0 1.689-.214 2.436-.624l.861-.472v6.096c-2.761 2.761-7.239 2.761-10 0v-6.096z",
    fill: "#fce0b9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m20 35.904.862.472c.747.41 1.584.624 2.436.624h3.405c.851 0 1.689-.214 2.436-.624l.861-.472v6.096c-.158.158-.323.304-.491.444l-9.509-6.158z",
    fill: "#d4b994"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m24 15h-4v2h4c3.866 0 7-3.134 7-7v-2c0 3.866-3.134 7-7 7z",
    fill: "#3d2012"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m30 15h-1.106c-1.262 1.236-2.988 2-4.894 2h6c3.866 0 7-3.134 7-7v-2c0 3.866-3.134 7-7 7z",
    fill: "#4d2817"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m39 14.317c-.91.433-1.925.683-3 .683h-1.106c-1.262 1.236-2.988 2-4.894 2h6c1.075 0 2.09-.25 3-.683 2.363-1.124 4-3.527 4-6.317v-2c0 2.791-1.637 5.193-4 6.317z",
    fill: "#3d2012"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m10 57 10-2h6c1.657 0 3 1.343 3 3v4h-19z",
    fill: "#fce0b9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m14 29.19v-9.19h-2c-2.209 0-4 1.791-4 4v4c0 2.209 1.791 4 4 4h2.709c-.455-.857-.709-1.817-.709-2.81z",
    fill: "#606060"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m11 29v-4c0-1.862 1.278-3.413 3-3.859v-1.141h-2c-2.209 0-4 1.791-4 4v4c0 2.209 1.791 4 4 4h.38c-.839-.733-1.38-1.798-1.38-3z",
    fill: "#878787"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m19 17h17v12.19c0 1.781-.791 3.469-2.159 4.609l-4.703 2.577c-.747.41-1.584.624-2.436.624h-3.405c-.851 0-1.689-.214-2.436-.624l-4.703-2.577c-1.367-1.14-2.158-2.829-2.158-4.609v-8.19z",
    fill: "#fce0b9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m27 25c-.552 0-1 .448-1 1v11h.702c.851 0 1.689-.214 2.436-.624l4.703-2.577c1.368-1.14 2.159-2.829 2.159-4.609v-4.19z",
    fill: "#f0d2a8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m29 28v8.441 4.559 9h14v-17c0-1.105.895-2 2-2s2 .895 2 2v17h14v-22z",
    fill: "#383838"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m45 31c-1.105 0-2 .895-2 2v17 7h4v-7-17c0-1.105-.895-2-2-2z",
    fill: "#383838"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m36 58v4h18v-4c0-.552-.448-1-1-1h-6-4-6c-.552 0-1 .448-1 1z",
    fill: "#383838"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m41 30.462v19.538h2v-17c0-1.105.895-2 2-2s2 .895 2 2v17h2v-19.538c0-1.36-1.791-2.462-4-2.462s-4 1.102-4 2.462z",
    fill: "#262626"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m36 59h18v3h-18z",
    fill: "#262626"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m14 21v3.25l2.23-1.672c3.096-2.323 6.862-3.578 10.733-3.578h9.037v-2h-17z",
    fill: "#f0d2a8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 25.5,
    fill: "#2b2210",
    rx: 1,
    ry: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 25.5,
    fill: "#2b2210",
    rx: 1,
    ry: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 25.5,
    fill: "#fff",
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 25.5,
    fill: "#fff",
    r: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramador);
export default __webpack_public_path__ + "static/media/programador.5472247b0bfd6207c63b7d0b46df4e94.svg";
export { ForwardRef as ReactComponent };